// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__bKvCz","topBottomGutter":"Layout_topBottomGutter__FBb71"};